const normalizeName = (value) => String(value ?? '').trim();

export const compareSublocationNames = (left, right) =>
  normalizeName(left?.name).localeCompare(normalizeName(right?.name), undefined, {
    sensitivity: 'base',
    numeric: true,
  });

export const sortSublocationsByName = (items = []) => {
  if (!Array.isArray(items) || items.length <= 1) return Array.isArray(items) ? [...items] : [];
  return [...items].sort(compareSublocationNames);
};
